
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Phone, Calendar, User } from "lucide-react";
import { Lead } from "@/types";

interface LeadInfoCardProps {
  lead: Lead;
}

export const LeadInfoCard = ({ lead }: LeadInfoCardProps) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex justify-between items-start">
          <div>
            <CardTitle className="text-xl">{lead.name}</CardTitle>
            <CardDescription>
              <div className="flex items-center gap-1 mt-1">
                <Phone className="h-3.5 w-3.5" />
                <span>{lead.phone}</span>
              </div>
            </CardDescription>
          </div>
          <div>
            <span className={`status-badge-${lead.status}`}>
              {lead.status.replace("-", " ")}
            </span>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
          <div className="flex items-center text-muted-foreground">
            <Calendar className="h-4 w-4 mr-1.5" />
            <span>{new Date(lead.created_at).toLocaleDateString()}</span>
          </div>
          {lead.email && (
            <div className="flex items-center text-muted-foreground">
              <User className="h-4 w-4 mr-1.5" />
              <span>{lead.email}</span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
